export default {
	common: {
		clearSelection: "Annuler la sélection",
		delete: "Supprimer",
		close: "Fermer",
	},
	catalogue: {
		pendingOrdersTitle: "Commandes en attente",
		pendingOrdersDescription:
			"Les commandes suivantes ont été demandées par les utilisateurs respectifs, mais n'ont pas encore été validées.",
		uploadButtonTooltip: "Sélectionner et téléverser des articles.",
		importTitle: "Import d'articles",
		importHint:
			"Faites glisser jusqu'à 10 fichiers (.step / .stp / .dxf) dans cette zone ou cliquez sur le bouton",
		emptyHint: "Encore un peu vide ici...",
		importInstructions:
			"Importez vos modèles CAO au format .step ou .dxf en les faisant glisser dans cette zone, ou cliquez sur le bouton ci-dessus pour sélectionner les fichiers.",
		importProcessDescription:
			"Blexon importe ensuite vos pièces, vérifie leur faisabilité et calcule automatiquement les prix.",
		videoIntro: "La vidéo montre les premières étapes avec Blexon",
		videoTitle:
			"Voici comment téléverser facilement des modèles CAO vers Blexon et commander directement en ligne des pièces en tôle découpées au laser sur mesure",
		searchLabel: "Rechercher un article :",
		searchPlaceholder: "Saisir le nom ou le numéro de l'article...",
		sortingLabel: "Tri :",
		userFilterLabel: "Afficher les articles de :",
		loadMoreTooltip: "Charge d'autres articles avec les filtres actuels.",
		loadMoreButton: "Charger plus",
		sortTypes: {
			createdDescending: "Plus récents en premier",
			createdAscending: "Plus récents en dernier",
			lastChangeDescending: "Dernières modifications en premier",
			lastChangeAscending: "Dernières modifications en dernier",
			nameAscending: "Par nom d'article A - Z",
			nameDescending: "Par nom d'article Z - A",
			materialNameAscending: "Par désignation de matériau A - Z",
			materialNameDescending: "Par désignation de matériau Z - A",
			materialThicknessAscending: "Par épaisseur de matériau (fine d'abord)",
			materialThicknessDescending: "Par épaisseur de matériau (épaisse d'abord)",
		},
		uploadWarningDialog: {
			title: "Fichiers incompatibles",
			invalidFormatText:
				"Les fichiers suivants ont un format non valide et ne peuvent pas être téléversés :",
			errorText:
				"Les fichiers suivants dépassent la taille de fichier maximale autorisée et ne peuvent pas être téléversés :",
			warningText:
				"Les fichiers suivants sont très volumineux et ne seront pas traités automatiquement :",
			warningHint:
				"Veuillez définir le matériau et l'épaisseur appropriés pour ces articles. Une fois blexonisés, les articles seront ajoutés à votre catalogue. Vous pourrez ensuite les envoyer à notre support pour vérification.",
			moreInfo:
				"Vous trouverez plus d'informations sur les tailles de fichiers autorisées et les causes des modèles CAO volumineux dans notre {blog}.",
			blogLinkText: "blog",
		},
		messages: {
			maxFilesExceeded: "Vous pouvez téléverser au maximum 10 modèles CAO à la fois.",
		},
	},
	assembly: {
		processing: "Traitement de l'assemblage en cours...",
		back: "Retour",
		title: "Assemblage : {articleId} | '{articleName}'",
		multiDeleteDialog: {
			title: "Supprimer plusieurs articles",
			deleting: "Suppression des articles en cours...",
			invalidStateText:
				"Les articles suivants sont soit verrouillés, soit en cours de calcul, et ne peuvent donc {not} être supprimés :",
			notWord: "pas",
			confirmText: "Voulez-vous vraiment supprimer {count} article(s) ?",
			noneDeletable: "Aucun des articles sélectionnés ne peut être supprimé.",
			deleteButton: "Supprimer",
		},
		messages: {
			deleteError: "Erreur lors de la suppression d'un article.",
		},
	},
	multiedit: {
		deleteButton: "Supprimer {count} article(s)",
		powderCoatButton: "Thermolaquer {count} article(s)",
		powderCoatTooltip:
			"Ajouter, modifier ou supprimer un thermolaquage pour tous les articles sélectionnés.",
		zincCoatButton: "Zinguer {count} article(s)",
		zincCoatTooltip:
			"Ajouter, modifier ou supprimer une galvanisation pour tous les articles sélectionnés.",
	},
	multieditAssembly: {
		deleteButton: "Supprimer {count} article(s)",
	},
	importArticle: {
		uploading: "Téléversement en cours...",
		articleNameLabel: "Nom de l'article",
		articleNumberLabel: "Numéro d'article (facultatif)",
		articleNumberPlaceholder: "Votre numéro d'article",
		quantityInAssembly: "{count} pièce(s)",
		thickness: "Épaisseur : {thickness}mm",
		noMaterialFoundHintMain:
			"Nous n'avons trouvé aucun matériau correspondant à l'épaisseur détectée. Veuillez sélectionner le matériau souhaité dans la liste et blexoniser l'article. En cas d'erreur, vous pouvez envoyer l'article à notre support pour vérification.",
		noMaterialFoundHintSubArticle:
			'Nous n\'avons trouvé aucun matériau correspondant à l\'épaisseur détectée. Nous recommandons de supprimer les inserts avec la "corbeille" à droite, puis de les définir dans le visualiseur CAO. Vous pouvez également retirer ainsi les "pièces non métalliques" avant le traitement.',
		materialPlaceholder: "Veuillez choisir un matériau...",
		thicknessPlaceholder: "Veuillez choisir une épaisseur...",
		pressJoinPlaceholder: "... ou choisissez un insert",
		noPressJoinsAvailable: "Aucun insert disponible",
		deleteTooltip: "Annule le processus d'import et supprime l'article de la liste.",
		deleteSubArticleTooltip: "Retirer ce corps de volume du modèle.",
		blexonisierenButton: "Blexoniser",
		blexonisierenTooltip:
			"Analyse l'article et détecte automatiquement les usinages. Le calcul du prix démarre.",
		pressJoinCategories: {
			selfClinchingNuts: "Écrous à sertir",
			selfClinchingThreadedStud: "Goujons filetés à sertir",
			selfClinchingThreadedStandoff: "Douilles filetées à sertir",
		},
		messages: {
			deleteError: "L'article n'a pas pu être supprimé.",
		},
	},
	importAssembly: {
		articleNameLabel: "Nom de l'article",
		articleNumberLabel: "Numéro d'article (facultatif)",
		articleNumberPlaceholder: "Votre numéro d'article",
		assemblyProcessingText: "Oh, un assemblage. Nous allons le décomposer...",
		materialPlaceholderAvailable: "Veuillez choisir un matériau...",
		materialPlaceholderUnavailable: "Aucun matériau commun disponible pour toutes les pièces",
		materialHint:
			"Ce matériau n'est pas disponible pour toutes les pièces. Veuillez sélectionner individuellement les matériaux manquants ci-dessous.",
		deleteTooltip: "Annule le processus d'import et supprime l'article de la liste.",
		blexonisierenButton: "Blexoniser",
		blexonisierenTooltip:
			"Analyse l'assemblage et détecte automatiquement les usinages. Le calcul du prix démarre.",
		messages: {
			deleteError: "L'article n'a pas pu être supprimé.",
		},
	},
	pendingOrder: {
		summary: "Commande en attente du {date} de {firstname} {lastname} ({count} position(s))",
		addToCartTooltip: "Ajoute la commande au panier.",
		addToCartButton: "Dans le panier",
		deleteTooltip: "Supprime la commande.",
		deleteDialog: {
			title: "Êtes-vous sûr(e) ?",
			text: "La commande de {firstname} {lastname} avec {count} position(s) doit-elle être supprimée ? Cette action est irréversible.",
		},
	},
};
